import React from 'react'
import styles from './Muted.module.scss'

interface MutedProps {
  children: React.ReactNode
  className?: never
}

export const Muted: React.FC<MutedProps> = ({ children }) => (
  <span className={styles.muted}>{children}</span>
)
